module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_70.05d3963b.mp3";